<template>
    <v-dialog
      v-model="showAlert"
      hide-overlay
      persistent
      width="500"
    >
        <v-card>
            <v-alert
                :value="showAlert"
                transition="scale-transition"
                :type="type"
            >
                {{ message }}
            </v-alert>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    outlined
                    @click="$emit('closeAlert')"
                >
                    Κλείσιμο
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            showAlert:
                {
                    type: Boolean,
                    default: false
                },
            message:
                {
                    type: String,
                    default: ''
                },
            type:
                {
                    type: String,
                    default: 'error'
                }
        },
        data() {
            return {
            }
        },
        watch: {
        },
        created() {
        },
        methods: {
        }
    }
</script>
